import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormField, FormItem, FormLabel, FormDescription } from '@/components/ui/form'
import type { ObjectFormData } from '../schema'

interface FloorPlanTabProps {
    form: UseFormReturn<ObjectFormData>
}

export function FloorPlanTab({ form }: FloorPlanTabProps) {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            <FormField
                control={form.control}
                name="FloorPlanImage"
                render={() => (
                    <FormItem>
                        <FormLabel>{t('objects.floorPlan')}</FormLabel>
                        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                            <p className="text-muted-foreground">
                                {t('objects.floorPlanPlaceholder')}
                            </p>
                            <FormDescription className="mt-2">
                                {t('objects.floorPlanDescription')}
                            </FormDescription>
                        </div>
                    </FormItem>
                )}
            />
        </div>
    )
}
